module.exports = __webpack_public_path__ + "img/14.113cb73a.png";